<div *ngIf="currentStatus" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px" [ngClass]="cssClass" class="label">
  <span>{{currentStatus?.label}}</span>
  <mat-icon *ngIf="currentStatus.tooltip; else onlyIcon" [matTooltip]="currentStatus.tooltip"
  [matTooltipClass]="'status-tooltip-'+currentStatus.icon">{{currentStatus.icon}}</mat-icon>
  <ng-template #onlyIcon>
    <mat-icon>{{currentStatus?.icon}}</mat-icon>
  </ng-template>
</div>
<span *ngIf="!currentStatus">{{value}}</span>